module.exports = __webpack_public_path__ + "media/images/icon-period-tab@3x-15cd50a006933fa210f997ec906256c7.png";